"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeWydenHighContrast = void 0;
const tslib_1 = require("tslib");
const wyden_logo_negative_png_1 = tslib_1.__importDefault(require("../assets/images/wyden-logo-negative.png"));
const wyden_logo_positive_png_1 = tslib_1.__importDefault(require("../assets/images/wyden-logo-positive.png"));
const wyden_logomarca_negative_png_1 = tslib_1.__importDefault(require("../assets/images/wyden-logomarca-negative.png"));
const wyden_logomarca_positive_png_1 = tslib_1.__importDefault(require("../assets/images/wyden-logomarca-positive.png"));
const themeWydenHighContrast = (temaLift) => {
    const temaBase = {
        name: 'wyden',
        // Breakpoints
        xs: 375,
        ms: 576,
        sm: 768,
        md: 1024,
        ml: 1360,
        lg: 1440,
        xl: 1920,
        // Offset
        offsetXs: 24,
        offsetMs: 32,
        offsetSm: 40,
        offsetMd: 48,
        offsetLg: 72,
        offsetMl: 64,
        offsetXl: 64,
        // Media Query
        gutterWidth: 32,
        numberOfColumns: 12,
        // Primary Colors
        p001: temaLift.PrimaryActionColorPure,
        p002: temaLift.NeutralColorDarkPure,
        p003: temaLift.NeutralColorDarkPure,
        // Secundary Colors
        s001: '#B4FCF1',
        s002: '#F2A542',
        s003: temaLift.PrimaryActionColorHigh,
        // Actions Colors
        action001: temaLift.PrimaryActionColorPure,
        action002: '#B8669D',
        action003: '#CF99BD',
        action004: temaLift.PrimaryActionColorHigh,
        action005: temaLift.PrimaryActionColorLow,
        // Greys Colors
        grey001: temaLift.NeutralColorDarkLow,
        grey002: temaLift.NeutralColorDarkHigh,
        grey003: temaLift.NeutralColorDarkHigh,
        grey004: temaLift.NeutralColorLightLow,
        grey005: temaLift.NeutralColorLightHigh,
        // Feedback Colors
        success: temaLift.FeedbackColorPositivePure,
        successLight: temaLift.FeedbackColorPositiveHigh,
        error: temaLift.FeedbackColorNegativePure,
        errorLight: temaLift.FeedbackColorNegativeHigh,
        warning: temaLift.FeedbackColorWarningPure,
        warningLight: temaLift.FeedbackColorWarningHigh,
        // Background Colors
        bgSystemPure: temaLift.BackgroundColorSystemPure,
        bgSystemLow: temaLift.BackgroundColorSystemLow,
        bgSystemHigh: temaLift.BackgroundColorSystemHigh,
        bgPublic01Pure: temaLift.BackgroundColorPublic01Pure,
        bgPublic01Low: temaLift.BackgroundColorPublic01Low,
        bgPublic01High: temaLift.BackgroundColorPublic01High,
        bgPublic02Pure: temaLift.BackgroundColorPublic02Pure,
        bgPublic02Low: temaLift.BackgroundColorPublic02Low,
        bgPublic02High: temaLift.BackgroundColorPublic02High,
        // Extras Colors
        pink: '#FF5790',
        pinkLight: '#FFE3ED',
        purple: '#D156D3',
        purpleLight: '#FBE3FF',
        violet: '#8E56E3',
        violetLight: '#EEE3FF',
        blue: '#5A9CFF',
        blueLight: '#E3F3FF',
        teal: '#26A69A',
        tealLight: '#E3FFFC',
        orange: '#FF8743',
        orangeLight: '#FFEDE3',
        white: temaLift.NeutralColorLightPure,
        black: temaLift.NeutralColorDarkPure,
        // Logos
        logomarcaPositive: wyden_logomarca_positive_png_1.default,
        logoPositive: wyden_logo_positive_png_1.default,
        logomarcaNegative: wyden_logomarca_negative_png_1.default,
        logoNegative: wyden_logo_negative_png_1.default,
        // Img Login
        imgLoginTitleAluno: 'Foto de LinkedIn Sales Navigator',
        imgLoginTitleProfessor: 'Foto de Christina Morillo no Pexels',
    };
    // Combina o tema base com todos os tokens do Lift
    return Object.assign(Object.assign({}, temaBase), temaLift);
};
exports.themeWydenHighContrast = themeWydenHighContrast;
